import * as constants from '../../../vendor/cdt/checkout/src/checkout-web/src/scripts/config/constants.js';
import Address from './address.js';

export default class extends Address {
    constructor(options = {}) {
        super(options);
        this.checkbox = this.selectors.nameAttr('form[' + options.enableForm + '][enabled]');
        this.addressBlock = this.elementIdentifier + '_block';
    }

    setup() {
        super.setup();
        this.elementClassHandler.hide(document.querySelector(this.selectors.dataAttr(this.manualAddressBlock)));
        this.elementClassHandler.hide(document.querySelector(this.selectors.dataAttr(this.addressBlock)));
        this.setupDeliveryToggle();
    }

    setupDeliveryToggle() {
        if (document.querySelector(this.checkbox) && document.querySelector(this.checkbox).checked === true) {
            this.toggleDeliveryAddress(true);
        } else {
            this.removeRequiredFields();
        }
        document.querySelector(this.checkbox).addEventListener('click', (e) => {
            this.toggleDeliveryAddress(e.target.checked);
        });
    }

    toggleDeliveryAddress(checked) {
        if (checked === true) {
            this.elementClassHandler.show(document.querySelector(this.selectors.dataAttr(this.elementIdentifier + '_block')));
            this.setRequiredFields(this.selectors.querySelectorArray('.' + constants.MDL_TEXTFIELD_INPUT_CLASS, this.container), this.nonRequiredFields);
        } else {
            this.elementClassHandler.hide(document.querySelector(this.selectors.dataAttr(this.elementIdentifier + '_block')));
            this.removeRequiredFields();
        }
        this.clearSearchForm();
    }
}
